<ah-loading-overlay [isVisible]="isLoading"></ah-loading-overlay>
<!-- Only on Mobile -->
 @if (responsive) {
    <div class="selected-row-center">
        @if (hasBarcodeField && deviceService | isMobile) {
            <button
                class="mobile-barcode-search-button">
                <img class="clickable" style="filter: invert(50%)" src="../../../assets/layout/images/barcode-scan.svg">
            </button>
        }
        @if (hasBarcodeField) {
            <div class="flex-1 searchbox mobile-searchbox" [ngClass]="{ 'mobile-searchbox-event-table': isEventTable}">
                <input #gb type="text" placeholder="Search" [value]="tt.filters && tt.filters['global']?.value || ''" (input)="onFilterGlobal($event.target.value)"
                    (keyup.enter)="onFilterGlobal($event.target.value, true)" [(ngModel)]="filterText">
            </div>
        }
        @if (!hasBarcodeField) {
            <div class="flex-1 searchbox mobile-searchbox-no-barcode" [ngClass]="{ 'mobile-searchbox-event-table': isEventTable}">
                <input #gb type="text" placeholder="Search" [value]="tt.filters && tt.filters['global']?.value || ''" (input)="onFilterGlobal($event.target.value)"
                    (keyup.enter)="onFilterGlobal($event.target.value, true)" [(ngModel)]="filterText">
            </div>
        }
        <div>
            <button mat-raised-button (click)="tt.filters && onFilterGlobal(tt.filters['global']?.value, true)" ngClass.xs="mobile-button">
                <mat-icon svgIcon="search"></mat-icon>
            </button>
        </div>
        <p-menu #mobileMenu appendTo="body" popup="true" [model]="mobileOptions">
            <ng-template pTemplate="item">
                <p-multiSelect placeholder="Search" styleClass="mat-raised-button" class="column-filter search-row-space"
                    [options]="allFieldOptions" selectedItemsLabel="{0} items selected" [(ngModel)]="selectedFieldOptions" [autofocusFilter]="true"></p-multiSelect>
            </ng-template>
        </p-menu>
        <button (click)="mobileMenu.toggle($event)" class="mobile-column-button">
            <mat-icon svgIcon="view_week"></mat-icon>
        </button>
        @if (isEventTable) {
            <div>
                @if (fields && canEdit) {
                    <button class="create-button" ngClass.xs="mobile-create" mat-mini-fab (click)="createAsset()" [disabled]="isLoading">
                        <mat-icon>add</mat-icon>
                    </button>
                }
            </div>
        }
    </div>
 }

 <!-- Only on Desktop -->
  @if (!responsive) {
    <div class="search-row search-value">
        <!-- Showing Dropdown for Franchise and Group Tables -->

        @if (isStudioTable || isDivisionTable || (isFranchiseTable && indexType === assetIndexTypes.ForReview) || (isTransactionTable && indexType === assetIndexTypes.Excluded) ||  !canViewHistorical || (isRequestTable && requestType === RequestTypes.Requester) || (isDivisionGroupTable && !isStudioAdmin) || (isFranchiseGroupTable && !isStudioAdmin) || (isDivisionSubGroupTable && !isStudioAdmin) || (isFranchiseSubGroupTable && !isStudioAdmin)) {
            <div></div>
        }
        @if (assetToggleOptions.length && ((isDivisionGroupTable || isFranchiseGroupTable || isStudioGroupTable) || (isDivisionSubGroupTable || isFranchiseSubGroupTable || isStudioSubGroupTable) || (isFranchiseTable || isDivisionTable)&& currentView === assetIndexTypes.Default)) {
            <div class="asset-toggle">
                <label class="showing-label">Showing: </label>
                <p-select [disabled]="(isStudioGroupTable || isStudioSubGroupTable)" class="toggle-dropdown flex-60" [options]="assetToggleOptions" [ngModel]="assetTypesShown" placeholder="Select Assets to display" scrollHeight="400px"
                    (onChange)="toggleAssets($event)">
                    <ng-template let-assetToggleOption #item>
                        <p class="label">{{assetToggleOption.label}}</p>
                        <!-- <br> -->
                        <p class="sub-label">{{assetToggleOption.subLabel}}</p>
                    </ng-template>
                </p-select>
            </div>
        }
    
        <!-- Showing Dropdown for Transaction Table -->
        @if(isTransactionTable && currentView === assetIndexTypes.Default) {
             <div class="asset-toggle">
                 <label class="showing-label">Showing: </label>
                 <p-select class="toggle-dropdown flex-60" [options]="transactionToggleOptions" [ngModel]="transactionTypesShown" placeholder="Select Transactions to display" scrollHeight="400px"
                     (onChange)="toggleTransactions($event)">
                     <ng-template let-transactionToggleOption pTemplate="item">
                         <p class="label">{{transactionToggleOption.label}}</p>
                     </ng-template>
                 </p-select>
             </div>
        }
    
        <!-- Only for Request View -->
        @if(isRequestTable && requestType !== RequestTypes.Requester && (request.status === RequestStatus.Incomplete || request.status === RequestStatus.Submitted || request.status === RequestStatus.Confirmed)) {
            <div>
                <button color="primary" class="thumb-down-button" [disabled]="!selectedAssets.size" mat-raised-button
                    (click)="approveAssets(false)" matTooltip="Deny">
                    Deny
                </button>
                <button color="primary" class="thumb-up-button" [disabled]="!selectedAssets.size" mat-raised-button
                    (click)="approveAssets(true)" matTooltip="Approve">
                    Approve
                </button>
             </div>
        }
        <!-- End of Only for Request View -->
        @if (isEventTable) {
            <div class="flex-10">
                @if (fields && canEdit) {
                    <button class="table-header-circle-btn" mat-mini-fab (click)="onOpenCreateDialog()"
                        matTooltip="Create">
                        <mat-icon>add</mat-icon>
                    </button>
                }
            </div>
        }
        <!-- Export Options -->
        <div class="flex-row">
            @if (isExportAllVisible) {
                <button style="margin-right:10px;height: 41px;"
                    mat-raised-button color="primary"
                    label="Export All" (click)="expotAllCSV()">
                    Export All
                </button>
            }
            <p-tieredMenu #exportMenu appendTo="body" [popup]="true" [model]="exportOptions"></p-tieredMenu>
            @if (hideBulkOption == false) {
                <button style="height: 41px;"
                    [disabled]="isTransactionTable | isBulkOptionsDisabled : selectedTransactions : selectedAssets : indexType : transactionTypesShown : assetTypesShown: false" mat-raised-button color="primary"
                    label="Export" (click)="exportMenu.toggle($event)">
                    Export
                </button>
            }
        </div>
    </div>
  }


<p-table
    #tt
    [columns]="selectedFields"
    [value]="isTransactionTable ? lazyTransactions : lazyAssets"
    dataKey="id"
    styleClass="clickable shadow"
    rowExpandMode="single"
    [expandedRowKeys]="expandedItems"
    [reorderableColumns]="true"
    (onColReorder)="onColReorder($event)"
    (onFilter)="onTableFilter($event)"
    responsiveLayout="scroll"
    [rowsPerPageOptions]="(defaultRowsPerPage() == 50) ? [50,100,250] : [10,50,100,250]"
    [resizableColumns]="true"
    (onSort)="onTableSort($event)"
    [loading]="isLoading"
    [paginator]="true"
    paginatorPosition="both"
    [rows]="rowsPerPage"
    [lazy]="true"
    (onLazyLoad)="lazyLoad($event)"
    [lazyLoadOnInit]="false"
    stateStorage="local"
    [stateKey]="stateKey"
    [totalRecords]="isTransactionTable ? transactions.length : assetCountTotal"
    [rowTrackBy]="rowTrackBy"
    [filters]="filters"
    [tableStyle]="{ 'width': '100%' }"
>
    <ng-template pTemplate="caption">
        <div class="search-header"  *ngIf="!responsive">
            <div class="flex-row caption-section">
                <div class="flex-1 searchbox" style="width: 250px; margin-right: 10px;">
                    <mat-icon svgIcon="search"></mat-icon>
                    <input #gb type="text" placeholder="Search" [value]="tt.filters && tt.filters['global']?.value || ''" (input)="onFilterGlobal($event.target.value)"
                     (keyup.enter)="onFilterGlobal($event.target.value, true)" matTooltip="Click search or hit enter to search">
                </div>
                <div class="flex-10">
                    <button color="primary" mat-raised-button (click)="onFilterGlobal(filterText, true)" matTooltip="Search">
                        Search
                    </button>
                </div>
            </div>
            <div class="caption-section">

                <p-tieredMenu #addUpdateMenu appendTo="body" [popup]="true" [model]="addUpdateOptions"></p-tieredMenu>
                <button *ngIf="hideBulkOption == false && addUpdateOptions.length" class="bulk-button"
                    [disabled]="isTransactionTable | isBulkOptionsDisabled : selectedTransactions : selectedAssets : indexType : transactionTypesShown : assetTypesShown: true" mat-raised-button color="primary"
                    label="Add/Update" (click)="addUpdateMenu.toggle($event)">
                    Add/Update
                </button>
                <p-tieredMenu #eventMenu appendTo="body" [popup]="true" [model]="eventOptions"></p-tieredMenu>
                <button *ngIf="hideBulkOption == false && eventOptions.length" class="bulk-button"
                    [disabled]="isTransactionTable | isBulkOptionsDisabled : selectedTransactions : selectedAssets : indexType : transactionTypesShown : assetTypesShown" mat-raised-button color="primary"
                    label="events" (click)="eventMenu.toggle($event)">
                    Event Options
                </button>

                <p-tieredMenu #bulkReconcileMenu appendTo="body" [popup]="true" [model]="bulkReconcileOptions"></p-tieredMenu>
                <button *ngIf="hideBulkOption == false && isTransactionTable && currentView === assetIndexTypes.Default" class="bulk-button"
                    [disabled]="isTransactionTable | isBulkOptionsDisabled : selectedTransactions : selectedAssets : indexType : transactionTypesShown : assetTypesShown" mat-raised-button color="primary"
                    label="Bulk Reconcile" (click)="bulkReconcileMenu.toggle($event)">
                    Bulk Reconcile
                </button>

                <button *ngIf="hideBulkOption == false && moveOptionVisible" class="bulk-button"
                    [disabled]="isTransactionTable | isBulkOptionsDisabled : selectedTransactions : selectedAssets : indexType : transactionTypesShown : assetTypesShown: true" mat-raised-button color="primary"
                    label="Move" (click)="openMoveModal()">
                    Move
                </button>

                <button *ngIf="hideBulkOption == false && requestOptionVisible" class="bulk-button"
                    [disabled]="isTransactionTable | isBulkOptionsDisabled : selectedTransactions : selectedAssets : indexType : transactionTypesShown : assetTypesShown: true" mat-raised-button color="primary"
                    label="Request" (click)="openRequestAssetsModal()">
                    Request
                </button>

                <button *ngIf="hideBulkOption == false && mergeOptionVisible" class="bulk-button"
                    [disabled]="isTransactionTable | isBulkOptionsDisabled : selectedTransactions : selectedAssets : indexType : transactionTypesShown : assetTypesShown: true" mat-raised-button color="primary"
                    label="Merge" (click)="openMergeAssetsModal()">
                    Merge
                </button>


                <p-multiSelect placeholder="Search" appendTo="body" [matTooltipDisabled]="tooltip === false" (onPanelShow)="showTooltip()" (onPanelHide)="hideTooltip()" 
                    matTooltip="Choose Columns" resetFilterOnHide="true" tooltipPosition="bottom" #multiSelect [disabled]="isLoading" *ngIf="hideChooseColumns === false" 
                    styleClass="mat-raised-button" panelStyleClass="custom-height-panel" class="column-filter search-row-space" [panelStyle]="{'--item-count': heightPixel}"
                    [options]="allFieldOptions" [ngModel]="selectedFieldOptions" 
                    [virtualScroll]="true" [virtualScrollItemSize]="40" #multiSelectRef [autofocusFilter]="true" (onFilter)="onFilterChange($event)"
                    (onChange)="onSelectFields($event)" [filter]="!(deviceService | isMobile)" [showToggleAll]="false">
                    <ng-template #dropdownicon>
                        <mat-icon class="burger-icon">view_week</mat-icon>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <div class="custom-multiselect-header">
                            <button 
                                type="button"
                                class="close-button"
                                (click)="multiSelectRef.hide()"
                                aria-label="Close">
                                <i class="pi pi-times"></i>
                            </button>
                        </div>
                    </ng-template>
                </p-multiSelect>
             </div>
        </div>
        <div class="info-section">
            <div>
                <div *ngIf="tableType | isCaptionVisible : indexType : assetTypesShown : transactionTypesShown : responsive" class="caption-section">
                    <span *ngIf="!isAllAssetsSelected">
                        <span class="bold-text">{{isTransactionTable ? (selectedTransactions.size | number) : selectedAssets.size | number}}</span>
                        {{isTransactionTable ? selectedTransactions.size === 1 ? 'transaction is' : 'transactions are' : selectedAssets.size === 1 ? 'asset is' : 'assets are'}} selected.
                    </span>
                    <div *ngIf="isAllAssetsSelected | isSelectAllCaptionVisible : selectAllCheckedForPage : isTransactionTable : selectedTransactions : selectedAssets : assetCountTotal : transactions" class="link" (click)="onSelectAll(true)">Select all {{ (assetLimit &gt; this.turboTable.totalRecord) ? this.turboTable.totalRecords : (assetLimit == -1 || assetLimit &gt; this.turboTable.totalRecords)? (this.turboTable.totalRecords | number) : (assetLimit | number)}} {{isTransactionTable ? 'transactions' : 'assets'}} in the search results</div>
                    <div *ngIf="isAllAssetsSelected" class="selected-row-center">
                        <span>
                            <span class="bold-text">{{ (assetLimit &gt; this.turboTable.totalRecords) ? this.turboTable.totalRecords : (assetLimit == -1)? (this.turboTable.totalRecords | number) : (assetLimit | number)}}</span>
                            {{isTransactionTable ? 'transactions' : 'assets'}} in this table are selected.
                        </span>
                    </div>
                    <div *ngIf="selectAllCheckedForPage | isClearSelectionVisible : isTransactionTable : selectedTransactions : selectedAssets : isAllAssetsSelected" class="link" (click)="onSelectAll(false)">Clear selection</div>
                </div>
            </div>
            <div class="caption-section">
                <div id="adt_reset_filters_button" *ngIf="!(isTransactionMatchTable || isTransactionMatchReviewTable)" [ngClass]="disableClearFilter ? 'div-disable link' : 'link'" (click)="resetFilters()">
                    Clear Filters
                    <mat-icon svgIcon="replay"></mat-icon>
                </div>
                <div class="search-results" *ngIf="!responsive">
                    <span *ngIf="assetCountTotal <= assetLimit">
                        Search results:
                        <span class="bold-text">{{ turboTable.totalRecords | number}} {{ assetCountTotal | getPluralizedAssetOrTransaction : tableType }}</span>
                    </span>
                    <span *ngIf="assetCountTotal > assetLimit">
                        Search results:
                        <span *ngIf="disableClearFilter" class="bold-text">{{ (assetLimit == -1) ? "" : assetLimit | number }} {{(assetLimit == -1) ? "" : "of" }} </span>
                        <span class="bold-text">{{ assetCountTotal | number }}</span>
                        {{ assetCountTotal | getPluralizedAssetOrTransaction : tableType }}
                    </span>
                    <div *ngIf="isTransactionTable">
                        <ah-tooltip *ngIf="assetCountTotal > limit" style="margin-left: 5px" [tooltip]="warningTooltip" [isWarning]="true"></ah-tooltip>
                    </div>
                    <div *ngIf="!isTransactionTable">
                        <mat-icon style="margin-left: 5px; color: #ff5722" svgIcon="settings" (click)="onAssetLimit()" tooltip="Asset Limit Settings"></mat-icon>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="summary" styleClass="p-table-summary">
        <div *ngIf="!isLoading && isFiltered && turboTable.totalRecords === 0">
            <span>
                There are no {{isTransactionTable ? 'transactions' : 'assets'}} to display. Adjust your filters for more results.
            </span>
        </div>
        <div *ngIf="!isLoading && !isFiltered && turboTable.totalRecords === 0">
            <span>
                This table contains no {{isTransactionTable ? 'transactions' : 'assets'}}.
            </span>
        </div>
        <div *ngIf="isLoading">
            <span>Loading...</span>
        </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
        <!-- Headers -->
        <tr>
            <th style="width: 45px">
                @if (tableType | isSelectAllCheckboxVisible:indexType : assetTypesShown : transactionTypesShown) {
                    <mat-checkbox class="row-checkbox"
                        [(ngModel)]="selectAllCheckedForPage[turboTable.first]"
                        (change)="onSelectAllPageAssets()"
                        (click)="$event.stopPropagation()" matTooltip="Select all on current page">
                    </mat-checkbox>
                }
            </th>
            <th *ngFor="let field of columns; trackBy: field?.id"
                [pSortableColumn]="assetDataService.getSortField(field)" pReorderableColumn pResizableColumn
                [ngClass]="{'photo-column': field?.canonical_name === 'photos'}" [pSortableColumnDisabled]="field?.canonical_name === 'group_ids' || field.tyepe === fieldTypes?.MULTI_PICKLIST?.type" [matTooltip]="field | getColumnFitlerTooltip : tableType : customFieldNames : selectedProjectCurrencyId : selectedProjectIdsList">
                <div [ngSwitch]="field?.canonical_name">
                    <ah-project-currency-select *ngSwitchCase="'other_cost'" [currencies]="projectCurrencies$ | async"
                        [value]="selectedProjectCurrencyId" (change)="onSelectProjectCurrency($event)">
                    </ah-project-currency-select>
                    <span *ngSwitchDefault>{{ field?.name }}</span>
                     <p-sortIcon [field]="assetDataService.getSortField(field)" [style.display]="(field?.canonical_name === 'group_ids' || field?.canonical_name === 'assetEvents' || field?.type === fieldTypes?.MULTI_PICKLIST?.type) ? 'none' : null"></p-sortIcon>
                </div>
                <!-- Filters -->
                <div [ngSwitch]="field?.type" (click)="$event.stopPropagation()">
                    <p-select
                        *ngSwitchCase="field?.type === fieldTypes.CHECKBOX.type ? field?.type : ''"
                        appendTo="body"
                        [options]="checkboxOptions"
                        defaultLabel="Search"
                        (onChange)="onColumnFilter($event?.value, field)"
                        [styleClass]="(tt.filters && tt.filters[field?.canonical_name] && tt.filters[field?.canonical_name].value !== 'all') ? 'p-column-filter active-filter' : 'p-column-filter'"
                        (click)="$event.stopPropagation();"
                        [ngModel]="tt.filters[field?.canonical_name]?.value"
                        [filter]="!(deviceService | isMobile)"
                        [virtualScroll]="true" [virtualScrollItemSize]="30"
                        [autofocusFilter]="true"
                    ></p-select>
                  <p-multiSelect placeholder="Search" 
                       #multiSelectRef
                      *ngSwitchCase="field?.type === fieldTypes.PICKLIST.type || field?.type === fieldTypes.MULTI_PICKLIST.type ? field?.type : ''"
                      appendTo="body"
                      [options]="field?.canonical_name === standardFields.origin_currency.canonical_name
                          ? selectOptions.project_currency_id
                          : selectOptions[field?.canonical_name]"
                      defaultLabel="Search"
                      (onPanelShow)="onFilterPanelShow(field?.canonical_name)"
                      [styleClass]="(tt.filters && tt.filters[field?.canonical_name]) ? 'p-column-filter active-filter' : 'p-column-filter'"
                      (onChange)="onTempPicklistChange($event.value, field)"
                      (click)="$event.stopPropagation();"
                      [(ngModel)]="tempFilterSelections[field?.canonical_name]"
                      [filter]="!(deviceService | isMobile)"
                      [showToggleAll]="true"
                      [autofocusFilter]="true"
                      [virtualScroll]="true" 
                      [virtualScrollItemSize]="30"
                      (onFilter)="onMultiselectFilterChanges($event, field?.canonical_name)"
                      [panelStyle]="getMultiSelectPanelStyle(field)"
                     >
                     <ng-template pTemplate="header">
                        <div class="custom-multiselect-header">
                            <button 
                                type="button"
                                class="close-button"
                                (click)="multiSelectRef.hide()"
                                aria-label="Close">
                                <i class="pi pi-times"></i>
                            </button>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="footer">
                        <div class="filter-footer-buttons center-footer-buttons">
                            <button mat-raised-button matDialogClose (click)="applyPicklistFilter(field, multiSelectRef, true)">Clear</button>
                            <button mat-raised-button matDialogClose (click)="cancelPicklistFilter(field, multiSelectRef); $event.stopPropagation()">Cancel</button>
                            <button color="primary" mat-raised-button (click)="applyPicklistFilter(field, multiSelectRef)" matTooltip="Apply">
                                Apply
                            </button>
                        </div>
                    </ng-template>
                    <ng-template let-item pTemplate="item">
                            <span [style]="(field?.canonical_name === 'group_ids' && (item.label.split(' - ').length === 1 || item.label.split(' - ').length === 3) ) ? 'font-weight: bold;': 'font-weight: normal'" [ngClass]="{'p-disabled': item.value === null && nullDisabledMap?.[field?.canonical_name]}"
                            [attr.data-null-option]="item.value === null ? 'true' : null">{{item.label}}</span>
                    </ng-template>
                </p-multiSelect>
 
                    <span *ngSwitchCase="field?.type === fieldTypes.CURRENCY.type || field?.type === fieldTypes.NUMBER.type ? field?.type : ''">
                        <span *ngIf="(field?.canonical_name === 'other_cost' && selectedProjectCurrencyId) || (field?.canonical_name === 'local_cost' && selectedProjectIdsList && selectedProjectIdsList.length === 1) || (field?.canonical_name !== 'other_cost' && field?.canonical_name !== 'local_cost')">
                            <input pInputText type="number" onkeydown="return event.keyCode !== 69" placeholder="Min" (keydown)="$event.stopPropagation()" (keyup.enter)="onColumnFilter([costmin.value, costmax.value], field)" (click)="$event.stopPropagation();"
                                [class.active-filter]="tt.filters && tt.filters[field.canonical_name]" #costmin [ngModel]="(tt.filters && tt.filters[field.canonical_name])
                ? tt.filters[field.canonical_name].value[0] : []">
                <br/>
                            <input pInputText type="number" onkeydown="return event.keyCode !== 69" placeholder="Max" (keydown)="$event.stopPropagation()" (keyup.enter)="onColumnFilter([costmin.value, costmax.value], field)" (click)="$event.stopPropagation();"
                                [class.active-filter]="tt.filters && tt.filters[field.canonical_name]" #costmax [ngModel]="(tt.filters && tt.filters[field.canonical_name])
                ? tt.filters[field.canonical_name].value[1] : []">
                        </span>
                    </span>
                    <span *ngSwitchCase="field?.type === fieldTypes.DATE.type ? field?.type : ''">
                        <span class="p-date-filters">
                            <mat-form-field class="p-mat-date" appearance="outline">
                                <input
                                    [ngModel]="tt.filters && dateFiltersMin[field?.canonical_name] === undefined ? getInitialDateMin(tt.filters, field?.canonical_name) : dateFiltersMin[field?.canonical_name]"
                                    #datemin
                                    matInput
                                    [matDatepicker]="minpicker"
                                    readonly (click)="minpicker.open()"
                                    (dateChange)="onColumnFilter([datemin.value, datemax.value], field)"
                                    placeholder="Min"
                                    [class.active-filter]="dateFiltersMin[field?.canonical_name]">
                                <mat-datepicker-toggle class="p-mat-date-cal" matPrefix [for]="minpicker"></mat-datepicker-toggle>
                                <mat-icon class="p-mat-date-clear" (click)="clearDate(minpicker, [null, datemax.value], field)" matSuffix svgIcon="clear"></mat-icon>
                                <mat-datepicker [touchUi]="deviceService | isMobile" #minpicker></mat-datepicker>
                            </mat-form-field>
                            <mat-form-field class="p-mat-date" appearance="outline">
                                <input
                                    [ngModel]="tt.filters && dateFiltersMax[field?.canonical_name] === undefined ? getInitialDateMax(tt.filters, field?.canonical_name) : dateFiltersMax[field?.canonical_name]"
                                    #datemax
                                    matInput
                                    [matDatepicker]="maxpicker"
                                    readonly (click)="maxpicker.open()"
                                    (dateChange)="onColumnFilter([datemin.value, datemax.value], field)"
                                    placeholder="Max"
                                    [class.active-filter]="dateFiltersMax[field?.canonical_name]">
                                <mat-datepicker-toggle class="p-mat-date-cal" matIconSuffix [for]="maxpicker"></mat-datepicker-toggle>
                                <mat-icon class="p-mat-date-clear" (click)="clearDate(maxpicker, [datemin.value, null], field)" matSuffix svgIcon="clear"></mat-icon>
                                <mat-datepicker [touchUi]="deviceService | isMobile" #maxpicker></mat-datepicker>
                            </mat-form-field>
                        </span>
                    </span>
                    <span *ngSwitchDefault>
                        <span *ngIf="field?.canonical_name !== 'photos' && field?.canonical_name !== 'created_at' && field?.canonical_name !== 'updated_at'">
                            <input pInputText type="text" placeholder="Search" [value]="tt.filters[field?.canonical_name]?.value" (keyup.enter)="onColumnFilter($event?.target.value, field)"
                                class="p-column-filter" (keydown)="$event.stopPropagation()" (click)="$event.stopPropagation();" [class.active-filter]="tt.filters && tt.filters[field?.canonical_name]?.value">
                        </span>
                    </span>
                </div>
            </th>
            <th class="pill-column" *ngIf="showPillColumn" pResizableColumn></th>
            <!-- Request Only Columns -->
            <th class="request-column" *ngIf="request | isRequestConflictColumnVisible : tableType" pResizableColumn>
                <span>Multiple Requests</span>
            </th>
            <th class="request-column" *ngIf="request | isRequestStatusColumnVisible : tableType : requestType" pResizableColumn>
                <span>Request Status</span>
                <br/>
                <p-select appendTo="body" [options]="requestStatusOptions" (click)="$event.stopPropagation();" (onChange)="onFilterRequestStatus($event?.value, 'requestAsset.approved')"
                    defaultLabel="Search" [styleClass]="(tt.filters && tt.filters['requestAsset.approved']) ? 'multiselect-filter active-multiselect-filter' : 'multiselect-filter'"
                    [ngModel]="(tt.filters && tt.filters['requestAssetApproved']) ? tt.filters['requestAssetApproved'].value
                    : []"></p-select>
            </th>
            <th class="request-column" *ngIf="requestType | isRequestSentToColumnVisible : tableType : finalApproversEnabled" pResizableColumn>
                <span>Sent To</span>
            </th>
            <!-- End of Request Only Columns -->
            <!-- Asset Event Columns -->
            <th *ngIf="isEventTable" pSortableColumn="qty_on_loan">
                Qty. On Loan
                <p-sortIcon field="qty_on_loan"></p-sortIcon>
            </th>
            <th *ngIf="isEventTable" pSortableColumn="qty_returned">
                Qty. Returned
                <p-sortIcon field="qty_returned"></p-sortIcon>
            </th>
            <!-- End of Asset Event Columns -->
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-asset let-columns="columns" let-expanded="expanded">
        <tr (click)="onRowClick($event, asset)"
            [ngClass]="{
                'expando-header': isTransactionTable && expandedItems[asset.id],
                'cursor-default': !(asset | canAccessAssetDetails : user),
                'transaction-rows': isTransactionTable
            }"
            class="mobile-data-row">
            <td style="width: 3rem" *ngIf="!responsive">
                <mat-checkbox class="row-checkbox"
                    *ngIf="asset | isRowCheckboxVisible : tableType : indexType : assetTypesShown : transactionTypesShown"
                    [checked]="isTransactionTable ? selectedTransactions.has(asset.id) : selectedAssets.has(asset.id)"
                    (change)="onSelectRowCheckbox(asset)" (click)="
                    $event.stopPropagation()"></mat-checkbox>
            </td>
            <td *ngFor="let field of columns; trackBy: field?.id" [ngSwitch]="field?.canonical_name" (click)="openInlineEdit($event, field, asset)"
                class="mobile-data-cell" [ngClass]="{'long-text-field': field?.type === fieldTypes.LONG_TEXT_AREA.type}">
                <span class="mobile-data col-text">
                    <span *ngSwitchCase="standardFields.photos.canonical_name">
                        <img *ngIf="asset?.photos && asset?.photos.length" (click)="openAddPhotosModal(asset)" (click)="$event.stopPropagation()" class="asset-thumbnail-image"
                            src="{{asset?.photos[0]?.links.thumbnail}}">
                        <ng-container *ngIf="asset?.photos && !asset?.photos.length">
                            <mat-icon class="add-circle-icon" matTooltip="Add Photos" (click)="openAddPhotosModal(asset)" (click)="$event.stopPropagation()">add_circle_outline</mat-icon>
                        </ng-container>
                        <span class="preview" *ngIf="asset?.photos[0]?.links.preview">
                            <img src="{{asset?.photos[0]?.links.preview}}" class="asset-preview-image">
                        </span>
                    </span>
                    <span *ngSwitchCase="'import_payload'" ngClass.xs="display-none">
                        {{ asset?.import_payload ? 'Yes' : '' }}
                    </span>
                    <span *ngSwitchCase="'created_by_user'">
                        {{ removeQuotes(asset?.displayFields[field?.canonical_name]) }}
                    </span>
                    <span *ngSwitchCase="'other_cost'" ngClass.xs="display-none">
{{ asset?.displayFields.other_cost[selectedProjectCurrencyId] || '-' }}
                    </span>
                    <span *ngSwitchCase="'name'" class="mobile-name">
                        {{ asset?.displayFields[field?.canonical_name] }}
                    </span>
                    <div *ngSwitchCase="'character_id'">
                        <div *ngIf="asset?.displayFields['new_character']" class="new-pill">New</div>
                        <span>
                            {{asset?.displayFields[field?.canonical_name]}}
                        </span>
                    </div>
                    <div *ngSwitchCase="'set_id'">
                        <div *ngIf="asset?.displayFields['new_set']" class="new-pill">New</div>
                        <span *ngSwitchCase="'set_id'">
                            {{asset?.displayFields[field?.canonical_name]}}
                        </span>
                    </div>
                    <div *ngSwitchCase="'assetEvents'">
                        <div *ngFor="let item of asset?.displayFields[field?.canonical_name]; let i = index">
                            {{item.event.name}} {{i === asset?.displayFields[field?.canonical_name].length -1 ? '' : ',&nbsp;' }}
                        </div>
                    </div>
                    <div *ngSwitchCase="'group_ids'">
                        {{ asset?.displayFields[field?.canonical_name]?.join(', ')}}
                    </div>
                    <span *ngSwitchDefault>
                        <span *ngIf="[fieldTypes.LONG_TEXT_AREA.type, fieldTypes.HUGE_TEXT_AREA.type].includes(field?.type)">
                            {{ asset | truncateAssetField : field?.canonical_name }}
                        </span>
                        <span *ngIf="field?.type === fieldTypes.URL.type">
                            <a href="{{asset?.displayFields[field.canonical_name]}}" target="_blank">{{asset?.displayFields[field.canonical_name]}}</a>
                        </span>
                        <span *ngIf="![fieldTypes.LONG_TEXT_AREA.type, fieldTypes.HUGE_TEXT_AREA.type, fieldTypes.URL.type].includes(field?.type)">
                            {{asset?.displayFields[field?.canonical_name]}}
                        </span>
                    </span>
                </span>
            </td>
            <td class="pill-column" *ngIf="showPillColumn">
                <div class="missing-pill">
                    <div *ngIf="!assetValidLookup[asset.id]" class="invalid-pill">Data Missing</div>
                    <div *ngIf="assetValidLookup[asset.id]" class="valid-pill">Ready to go!</div>
                </div>
            </td>
            <!-- Request Only Columns -->
            <td class="pill-column mobile-data-cell" *ngIf="request | isRequestConflictColumnVisible : tableType">
                <div class="missing-pill mobile-data">
                    <div *ngIf="asset.requestAsset.hasConflict">
                        <button class="conflict-button" (click)="onShowRequestConflicts($event, asset.requestAsset.id)"
                            matTooltip="Show conflicts">
                            <mat-icon svgIcon="flag"></mat-icon>
                        </button>
                    </div>
                </div>
            </td>
            <td class="pill-column mobile-data-cell" *ngIf="request | isRequestStatusColumnVisible : tableType : requestType">
                <div class="missing-pill mobile-data">
                    <div *ngIf="asset.requestAsset.approved !== null && asset.requestAsset.approved"
                        class="approved-pill valid-pill">Approved</div>
                    <div *ngIf="asset.requestAsset.approved !== null && !asset.requestAsset.approved"
                        class="denied-pill invalid-pill">Denied</div>
                </div>
            </td>
            <td class="pill-column mobile-data-cell" *ngIf="requestType | isRequestSentToColumnVisible : tableType : finalApproversEnabled">
                <span class="mobile-data">
                    {{asset?.requestAsset.finalApproversSentTo}}
                </span>
            </td>
            <!-- End of Request Only Columns -->
            <!-- Asset Event Columns -->
            <td *ngIf="isEventTable" (click)="openInlineEdit($event, field, asset)">
                {{ asset && assetEventForAssetIds && assetEventForAssetIds[asset.id] ? assetEventForAssetIds[asset.id].qty_on_loan : 0 }}
            </td>
            <td *ngIf="isEventTable" (click)="openInlineEdit($event, field, asset)">
                {{ asset && assetEventForAssetIds && assetEventForAssetIds[asset.id] ? assetEventForAssetIds[asset.id].qty_returned : 0 }}
            </td>
            <!-- End of Asset Event Columns -->
        </tr>
    </ng-template>
    <ng-template pTemplate="expandedrow" let-transaction>
        <tr class="expando-row" ngClass.xs="display-none">
            <td [attr.colspan]="selectedFields.length + 1">
                <ah-transaction-expando-row
                    [inputFields]="fields"
                    [transaction]="transaction"
                    [characters]="characters | async"
                    [sets]="sets | async"
                    [departments]="departmentList | async"
                    [subDepartments]="subDepartments | async"
                    [locations]="locations$ | async"
                    [dispositions]="dispositions$ | async"
                    [excludedDispositions]="excludedDispositions$ | async"
                    [franchise]="franchise"
                    [projects]="projectList | async"
                    (matchAssets)="matchAssets($event)"
                    (matchForReview)="matchForReview($event)"
                    (splitAssets)="splitAssets($event)"
                    [indexType]="indexType">
                </ah-transaction-expando-row>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="paginatorleft">
        <div class="total-results"></div>
    </ng-template>
    <ng-template pTemplate="paginatorright">
        <span style="margin-right: -10em;" class="total-results"> Results Per Page </span>
        <span class="total-results">{{ tableType | getPaginatorDisplay : rowsPerPage : tt.first : tt.totalRecords }}</span>
        <span class="total-count">Total: {{turboTable.totalRecords}}</span>
    </ng-template>
</p-table>
<button *ngIf="windowScrolled" matTooltip="Back to Top" color="primary" (click)="scrollToTop()" class="scroll-to-top" mat-mini-fab>
    <mat-icon>arrow_upward</mat-icon>
</button>
